import { Component,OnInit } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';

//service
import { AppSharedService } from '../service/app_shared';

//types
import { LoginInfo } from '../model/types';

//page
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-logout',
  templateUrl: 'logout.html',
})

export class LogoutPage implements OnInit{

  //constructor
  constructor(public navCtrl: NavController
              , public navParams: NavParams 
              , public storage: Storage
              , private http: HttpClient
              , public appSharedService:AppSharedService
              , public loadingCtrl : LoadingController
            ) {            
  }

  //initilization
  ngOnInit() {
    this.doLogout();
  }

  // log out
  doLogout(){
   
        //create loader
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
  


    this.storage.get(this.appSharedService.configInfo.applicationInfo.loginStorageName).then((userinfo:LoginInfo) => {    
     
      if(userinfo!=null){
        
        var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlLogout+userinfo.Token);
        
        // show loader
        loading.present();

        // the service call
        this.http.get(url)
        .subscribe(() => {
            this.storage.clear();
            this.navCtrl.setRoot(LoginPage);
            loading.dismiss();
          })
      }
      else
      {
        this.storage.clear();
        this.navCtrl.setRoot(LoginPage);
      }
    });
    }
  }



// WEBPACK FOOTER //
// ./src/pages/logout/logout.ts